function initializeExpandFooterMenuAction() {
  // Get all accordion buttons
  const accordionButtons = document.querySelectorAll(".footer-block__heading");

  // Add click event listeners to each button
  accordionButtons.forEach(button => {
    button.addEventListener("click", function () {
      // Toggle the max-height of the associated content when the button is clicked
      const content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        button.classList.remove("footer-block__heading--active");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        button.classList.add("footer-block__heading--active");
      }
    });
  });

}


window.addEventListener('DOMContentLoaded', () => {
  initializeExpandFooterMenuAction();
});

